/* eslint-disable */
(function IIFE() {
    const btn = document.querySelector('.b-clinic-interview__button_js');

    if (!btn) return;

    const container = document.querySelector('.b-clinic-interview_js');

    btn.addEventListener('click', () => {
        container.classList.toggle('b-clinic-interview_is_expanded');
        window.dispatchEvent(new Event('redraw'))
    });
})();
